import script from "./ConversationActionsShortcut.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConversationActionsShortcut.vue?vue&type=script&setup=true&lang=ts"

import "./ConversationActionsShortcut.vue?vue&type=style&index=0&id=415e1670&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-415e1670"]])

export default __exports__